"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Row;
exports.getRowProps = getRowProps;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _createProps = _interopRequireDefault(require("../../utils/createProps"));
var _types = require("../../utils/types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var rowKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];
var propTypes = {
  reverse: _propTypes["default"].bool,
  start: _types.ViewportSizeType,
  center: _types.ViewportSizeType,
  end: _types.ViewportSizeType,
  top: _types.ViewportSizeType,
  middle: _types.ViewportSizeType,
  bottom: _types.ViewportSizeType,
  around: _types.ViewportSizeType,
  between: _types.ViewportSizeType,
  className: _propTypes["default"].string,
  tagName: _propTypes["default"].string,
  children: _propTypes["default"].node
};
function getRowClassNames(props) {
  var modificators = [props.className, 'row'];
  for (var i = 0; i < rowKeys.length; ++i) {
    var key = rowKeys[i];
    var value = props[key];
    if (value) {
      modificators.push("".concat(key, "-").concat(value));
    }
  }
  if (props.reverse) {
    modificators.push('reverse');
  }
  return modificators;
}
function getRowProps(props) {
  return (0, _createProps["default"])(propTypes, props, getRowClassNames(props));
}
function Row(props) {
  return /*#__PURE__*/_react["default"].createElement(props.tagName || 'div', getRowProps(props));
}
Row.propTypes = propTypes;